import { ApiEndpoints } from "@shared/api/api-endpoints";
import { communicationApiClient } from "@shared/api/clients/apiClientFactory";
import { transformJsonToObject } from "@shared/utils/jsonToObjectTransformer";
import {
  ActivityFilters,
  ActivityLogFilters,
  ActivityLogListResponse,
} from "../types/activityLogs";

// Activity Log API Functions
export const activityLogTabApi = {
  // Get Activity Logs List
  getActivityLogs: async (
    filters: ActivityLogFilters,
  ): Promise<ActivityLogListResponse> => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "activityLog",
      "logs",
      (query) => {
        if (filters.remoteUtilityId)
          query.push("remote_utility_id", filters.remoteUtilityId.toString());
        if (filters.keyCode) query.push("key_code", filters.keyCode);
        else if (filters.entityId) query.push("request_id", filters.entityId);
        if (filters.actionType) query.push("action_type", filters.actionType);
        if (filters.limit) query.push("limit", filters.limit.toString());
        query.push("module", "cx");
        return query;
      },
    );

    const response = await communicationApiClient.get(url);
    return transformJsonToObject<ActivityLogListResponse>(response.data);
  },
};
